"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var listElements = document.querySelector("ul");
function parseSalary(salaryString) {
    return Number(salaryString.slice(1).split(",").join(""));
}
function sortList(listElement) {
    var _listElement;
    var employeesArray = _to_consumable_array(listElement.children);
    employeesArray.sort(function(a, b) {
        var cleanSalaryA = parseSalary(a.dataset.salary);
        var cleanSalaryB = parseSalary(b.dataset.salary);
        return cleanSalaryB - cleanSalaryA;
    });
    (_listElement = listElement).append.apply(_listElement, _to_consumable_array(employeesArray));
}
function getEmployees(list) {
    var itemsArray = _to_consumable_array(list.children);
    var employeesArray = itemsArray.map(function(item) {
        return {
            name: item.firstChild.textContent.trim(),
            position: item.dataset.position,
            salary: parseSalary(item.dataset.salary),
            age: item.dataset.age
        };
    });
    return employeesArray;
}
sortList(listElements);
getEmployees(listElements);

//# sourceMappingURL=index.a0b1ea49.js.map
